import {
    apiRequest,
    jenisJabatanDatatable,
    jenisJabatanSubmit
} from "../../../../../services/adapters/master/penialian360Service"

class JenisJabatanRepository {

    fetchDataTable = async (query, cancelToken) => {
        return await apiRequest("get", jenisJabatanDatatable, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchSubmit = async (query) => {
        return await apiRequest("post", jenisJabatanSubmit, {
            body: query
        }, true)
    }

}

export default JenisJabatanRepository